<template>
    <div>
        <span class="timeline-key">Amount(USD)  </span>: {{cost}} <br>
        <span v-if="extra.remarks"> <span class="timeline-key">Remarks  </span>: {{extra.remarks}}</span> <br>
    </div>
</template>

<script>
    export default {
        name: "BorderPenaltyApplied",
        props: ['extra', 'cost', 'user'],
    }
</script>
